<script setup lang="ts">
import { useToast } from 'vue-toastification';

import { EmbeddedEvent, sendEmbeddedMessage, useEnvironmentInfo } from '~~core';

import { TheHeader, SandboxWarning } from '../components';
import { useSerialSignature } from '../composables/use-serial-signature';

const { isSandbox, isEmbedded } = useEnvironmentInfo();
const { isInSerialSignature, isFromSerialSignature, totalToSign, totalSigned } = useSerialSignature();
const toast = useToast();
const { t } = useI18n();

onMounted(async () => {
  sendEmbeddedMessage(EmbeddedEvent.LOAD);

  if (isInSerialSignature.value && isFromSerialSignature.value) {
    toast.success(t('layout.serialSignature.feedback.success', {
      count: totalSigned.value,
      total: totalToSign.value,
    }), { timeout: 5000 });

    isFromSerialSignature.value = false;
  }
});
</script>

<template>
  <main :class="$style.main">
    <SandboxWarning v-if="isSandbox" />
    <TheHeader v-if="!isEmbedded" />

    <slot />
  </main>
</template>

<style lang="scss" module>
.main {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
